import { useGetIntegrationQuery } from "api/TenantSlug/Integration/hooks";
import { ApiMethodsForm } from "components/Forms/ApiMethodForm/ApiMethodsForm.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { useUser } from "hooks/useUser.ts";
import { PermissionEnum, RoleEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolScenarioIntegrationHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/scenario/_layout/integration/_layout/$integrationId/_layout/editor-old/"
)({
    component: IntegrationEditorOldPage,
    staticData: {
        permissions: [PermissionEnum.ToolIntegrationEditor],
        showInSideMenu: false,
        label: "pages.tool.scenario.integration.editor-old.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.scenario.integration.editor-old.title"),
        };
    },
});

function IntegrationEditorOldPage() {
    const { integrationId } = Route.useParams();
    const { data, isLoading, isError } = useGetIntegrationQuery(integrationId, {
        filter: { include: "formFields" },
    });
    const integration = data?.integration;
    const userUtils = useUser();
    const formId = FormId.ApiToolEditorForm;

    if (!integration?.id) {
        return (
            <QueryState isLoading={isLoading} isError={isError || !isLoading} errorKey="errors.loading_integration" />
        );
    }

    return (
        <TenantPage
            headerNavigationItems={() => getToolScenarioIntegrationHeaderItems()}
            isEdit
            saveFormId={
                userUtils
                    ?.getActiveTenant()
                    ?.userRoles?.some((role) => [RoleEnum.AdminFree, RoleEnum.AdminBeast].includes(role.name))
                    ? formId
                    : null
            }
        >
            <SectionContentWrapper withBackground>
                <ApiMethodsForm key={integrationId} integration={integration} />
            </SectionContentWrapper>
        </TenantPage>
    );
}
